import { useEffect, useState } from "react";
import { proposedCalculation } from "../calculationProposed";
import {
  sumSecondReplacementEquity,
  sumFuelCosts,
  sumMaintenanceCosts,
  sumYearValues,
} from "../../utils/methods";
import { extractValue } from "../commonFunction";

let dataFiscalYear = [
  { fiscalYear: "Current" },
  { fiscalYear: "Year1" },
  { fiscalYear: "Year2" },
  { fiscalYear: "Year3" },
  { fiscalYear: "Year4" },
  { fiscalYear: "Year5" },
];

const useFleetManagement = (
  currentFleetSize,
  replacementList,
  rowIndex,
  monthlyPaymentAmount,
  purchaseFinance,
  cashOutlay,
  newVehicle,
  maintanance,
  fuelListFilter,
  totalFuelSpend,
  fleetList,
  companyNameHeader,
  cycleFuelYearCost,
  cycleFuelYearCost2,
  cycleFuelYearCost3,
  cycleFuelYearCost4,
  cycleFuelYearCost5
) => {
  const [rowData, setRowData] = useState([]);
  const [proposedCycleYear, setProposedCycleYear] = useState(0);
  const [savingTotal, setSavingTotal] = useState(0);

  useEffect(() => {
    let yearValueList = [];
    if (replacementList?.length > 0) {
      const result = sumYearValues(replacementList);
      let proposedCycle = proposedCalculation(replacementList);
      let avgProposedCycle = proposedCycle / replacementList?.length;
      let roundedProposedCycle = Math.round(avgProposedCycle);

      const comtracVehicles = newVehicle?.filter(
        (v) => v?.years > 0 || v?.proposedCycle > 0 || v?.termMonths > 0
      );
      if (comtracVehicles && comtracVehicles.length > 0) {
        const avgComtracYears =
          comtracVehicles.reduce(
            (acc, v) =>
              acc +
              (v.proposedCycle ||
                v.years ||
                Math.round((v.termMonths || 12) / 12)),
            0
          ) / comtracVehicles.length;
        setProposedCycleYear(Math.round(avgComtracYears));
      } else {
        setProposedCycleYear(roundedProposedCycle || 0);
      }

      yearValueList.push(
        result?.year1Value,
        result?.year2Value,
        result?.year3Value,
        result?.year4Value,
        result?.year5Value
      );
    } else if (newVehicle?.length > 0) {
      const comtracVehicles = newVehicle?.filter(
        (v) => v?.years > 0 || v?.proposedCycle > 0 || v?.termMonths > 0
      );
      if (comtracVehicles && comtracVehicles.length > 0) {
        const avgComtracYears =
          comtracVehicles.reduce(
            (acc, v) =>
              acc +
              (v.proposedCycle ||
                v.years ||
                Math.round((v.termMonths || 12) / 12)),
            0
          ) / comtracVehicles.length;
        setProposedCycleYear(Math.round(avgComtracYears));
      }
    }
    if (currentFleetSize > 0) {
      dataFiscalYear?.map((items, index) => {
        items["fleetSize"] = currentFleetSize;
      });
    }

    let monthlyLease = [];
    let currentPayme = 0;
    if (monthlyPaymentAmount > 0) {
      let dataMonthlyLease1 = 0;
      let dataMonthlyLease2 = 0;
      let dataMonthlyLease3 = 0;
      let dataMonthlyLease4 = 0;
      let dataMonthlyLease5 = 0;
      if (purchaseFinance > 0) {
        if (rowIndex == 0) {
          dataMonthlyLease1 = (monthlyPaymentAmount / purchaseFinance) * 12;
        } else if (rowIndex == 1) {
          dataMonthlyLease2 = (monthlyPaymentAmount / purchaseFinance) * 13;
        } else if (rowIndex == 2) {
          dataMonthlyLease3 = (monthlyPaymentAmount / purchaseFinance) * 14;
        } else if (rowIndex == 3) {
          dataMonthlyLease4 = (monthlyPaymentAmount / purchaseFinance) * 15;
        } else if (rowIndex == 4) {
          dataMonthlyLease5 = (monthlyPaymentAmount / purchaseFinance) * 16;
        }
      } else {
        dataFiscalYear?.map((items, index) => {
          items["purchasedFinancial"] = 0;
        });
      }
      if (cashOutlay <= 0) {
        dataFiscalYear?.map((items, index) => {
          items["cashOutlay"] = "$ 0";
        });
      }
      if (currentPayme <= 0) {
        dataFiscalYear?.map((items, index) => {
          items["currentPayment"] = "$ 0";
        });
      }

      monthlyLease.push(
        { cyclingPayment: `$ 0` },
        { cyclingPayment: `$ ${dataMonthlyLease1}` },
        { cyclingPayment: `$ ${dataMonthlyLease2}` },
        { cyclingPayment: `$ ${dataMonthlyLease3}` },
        { cyclingPayment: `$ ${dataMonthlyLease4}` },
        { cyclingPayment: `$ ${dataMonthlyLease5}` }
      );
    }

    const equityResult = sumSecondReplacementEquity(replacementList, newVehicle);
    let equitySum = [
      {
        equityGain: "$ 0",
      },
      {
        equityGain: "$ 0", // Year 1: Manual field only
      },
      {
        equityGain: `$${equityResult?.equity2Gain}`,
      },
      {
        equityGain: `$${equityResult?.equity3Gain}`,
      },
      {
        equityGain: `$${equityResult?.equity4Gain}`,
      },
      {
        equityGain: `$${equityResult?.equity5Gain}`,
      },
    ];

    const maintenanceResult = sumMaintenanceCosts(maintanance);

    const maintananceData1 = [
      { maintanance: `$ ${maintenanceResult?.sumMaintenance}` },
      { maintanance: `$ ${maintenanceResult?.cycleYear1}` },
      { maintanance: `$ ${maintenanceResult?.cycleYear2}` },
      { maintanance: `$ ${maintenanceResult?.cycleYear3}` },
      { maintanance: `$ ${maintenanceResult?.cycleYear4}` },
      { maintanance: `$ ${maintenanceResult?.cycleYear5}` },
    ];
    if (maintananceData1?.length > 0) {
      dataFiscalYear?.map((items, index) => {
        items["maintenance"] = maintananceData1[index]?.maintanance;
      });
    }
    if (monthlyLease?.length > 0 && !rowIndex) {
      dataFiscalYear?.map((items, index) => {
        items["cyclingPayment"] = monthlyLease[index]?.cyclingPayment;
      });
    }
    if (rowIndex) {
      dataFiscalYear[rowIndex]["cyclingPayment"] =
        monthlyLease[rowIndex]?.cyclingPayment;
    }

    const resultFuelCost = sumFuelCosts(fuelListFilter);
    const fuelYearValues = [
      totalFuelSpend,
      resultFuelCost?.fuelYear1 || cycleFuelYearCost,
      resultFuelCost?.fuelYear2 || cycleFuelYearCost2,
      resultFuelCost?.fuelYear3 || cycleFuelYearCost3,
      resultFuelCost?.fuelYear4 || cycleFuelYearCost4,
      resultFuelCost?.fuelYear5 || cycleFuelYearCost5,
    ];
    let AnalysisFuel = [
      { fuel: `$ ${fuelYearValues[0] || 0}` },
      { fuel: `$ ${fuelYearValues[1] || 0}` },
      { fuel: `$ ${fuelYearValues[2] || 0}` },
      { fuel: `$ ${fuelYearValues[3] || 0}` },
      { fuel: `$ ${fuelYearValues[4] || 0}` },
      { fuel: `$ ${fuelYearValues[5] || 0}` },
    ];

    if (AnalysisFuel?.length > 0) {
      dataFiscalYear?.map((items, index) => {
        items["fuel"] = AnalysisFuel[index]?.fuel;
      });
    }
    if (yearValueList?.length > 0) {
      const years = fleetList.map((item) => item.year);
      const uniqueYears = new Set(years);
      const numberOfDifferentYears = uniqueYears.size;
      dataFiscalYear?.map((items, index) => {
        if (index === 0) {
          items["annualNeeds"] = parseFloat(
            Math.round(currentFleetSize / numberOfDifferentYears)
          );
        } else {
          items["annualNeeds"] = yearValueList[index - 1];
        }
        // Initialize purchasedFinancial to annualNeeds by default
        items["purchasedFinancial"] = 0;
      });
    }

    // Apply Vehicle Equity logic based on purchasedFinancial
    dataFiscalYear?.map((items, index) => {
      items["potentialVehicleEquity"] = equitySum[index]?.equityGain;
      const pf = Number(items["purchasedFinancial"] || 0);
       if (pf == 0) {
        items["vehicleEquity"] = "$ 0";
       } else {
        items["vehicleEquity"] = equitySum[index]?.equityGain;
      }
    });
    dataFiscalYear?.map((items, index) => {
      // Extract values and convert them to numbers
      const cycllePayment = Number(extractValue(items, "cyclingPayment"));
      const cashOut = Number(extractValue(items, "cashOutlay"));
      const current = Number(extractValue(items, "currentPayment"));
      const maintain = Number(extractValue(items, "maintenance"));
      const fuels = Number(extractValue(items, "fuel"));

      const sum = cycllePayment + cashOut + current + maintain + fuels;
      items["fleetSpeed"] = "$" + sum;
    });
    dataFiscalYear?.map((items, index) => {
      const spend = Number(extractValue(items, "fleetSpeed"));
      const equity = Number(extractValue(items, "vehicleEquity"));
      const currentYear = Number(extractValue(dataFiscalYear[0], "fleetSpeed"));
      const currentMinus = currentYear - spend;
      if (!dataFiscalYear.includes("Current")) {
        items["savings"] = currentMinus + equity;
      } else {
        items["savings"] = 0;
      }
    });
    let savingSum = 0;
    dataFiscalYear?.map((items, index) => {
      savingSum += Number(items?.savings);
    });

    setSavingTotal(savingSum);
    setRowData([...dataFiscalYear]);
  }, [
    companyNameHeader,
    currentFleetSize,
    replacementList,
    rowIndex,
    cycleFuelYearCost,
    cycleFuelYearCost2,
    cycleFuelYearCost3,
    cycleFuelYearCost4,
    cycleFuelYearCost5,
    newVehicle,
    fuelListFilter,
    monthlyPaymentAmount,
    purchaseFinance,
    cashOutlay,
    maintanance,
    totalFuelSpend,
    fleetList,
  ]);

  return {
    rowData,
    proposedCycleYear,
    savingTotal,
  };
};

export default useFleetManagement;
